module.exports = __webpack_public_path__ + "static/Newsweek-25c178dfdf330f78643739bf59976cf4.png";